export const ScreenSize = {
    desktop: '(min-width: 1285px)',
    tab: '(min-width: 768px)',
    mobile: '(max-width: 767px)'
}